<template>
  <div id="app">
  <v-layout ml-5 mt-2>
    <v-flex xs11>
      <v-card>
        <div style="margin-left:20px;"> 
        <h3 >จำนวนการตายทั่วประเทศย้อนหลัง 10 ปี </h3>
      </div>
        <div>
          <!-- <BarChart  :height="180"  :options="this.opt" :yymm="this.yymm" :action="41" :type="'housepops'"/> -->
             <BarChart  :height="80"   ref="test3" v-if="datacollection" :chartdata="datacollection"/>
        </div>
       </v-card>
    </v-flex>
   
  </v-layout>
  <v-layout ml-5 mt-2>
    <v-flex xs11>
      <v-card>
        <div>
           <v-layout>
          <v-flex ml-2 > <h3>จำนวนการตาย ย้อนหลัง 20 ปี  จังหวัด {{this.province.desc}} </h3></v-flex>
        
        </v-layout>
        <v-layout>
          <v-flex ml-5 xs4>                                
          <v-autocomplete
                v-model="province"
                placeholder="จังหวัด"
                :items="getListCC"
                item-text="descWithCode"
                item-value="code"
                maxlength="2"
                return-object
                v-on:change="checkCC"
          ></v-autocomplete>
          </v-flex>
        </v-layout>
         <BarChart ref="test2" v-if="datacollectionCC" :chartdata="datacollectionCC"  :width="1480"  />
        </div>
       </v-card>
    </v-flex>
  </v-layout>
  
  </div>
</template>

<script>
  // import LineChart from '@/components/LineChart'
  import BarChart from '@/components/BarChart'
  import PieChart from '@/components/PieChart'
  import axios from "axios";
  import general from '../js/general.js'
  // import BubbleChart from '@/components/BubbleChart'
  // import Reactive from '@/components/Reactive'

  export default {
    name: 'VueChartJS',
    components: {
      // LineChart,
      BarChart,
      PieChart,
      // BubbleChart,
      // Reactive
    },
    watch:{
     chartData(val) {
       console.log(val)
     }
    },
    data() {
      return {
        setyear:null,
        province:{ descWithCode: "10 : กรุงเทพมหานคร", code: 10, desc: "กรุงเทพมหานคร" },
        getListCC:null,
        piedata:null,
          yymm:{text:'ปี 2561',code: 2561},
           ticketsShowSummary: {
                labels: [],
                barThickness: 10,
                datasets: [
                    {
                        label: "Ingressos validados",
                        backgroundColor: [],
                        data: []
                    }
                ]
            },
      setOptions:{
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    return parseInt(tooltipValue).toLocaleString();
                  }
                }
              },
           scales: {
            yAxes: [{
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value) {
                        return value.toLocaleString();
                    }
                }  
            }]
          }
        }, 
        datacollection:null,
         getPlaceList:[
           {text: 'ปี 2554' , code: 2554 },
           {text: 'ปี 2555' , code: 2555 },
           {text: 'ปี 2556' , code: 2556 },
           {text: 'ปี 2557' , code: 2557 },
           {text: 'ปี 2558' , code: 2558 }, 
           {text: 'ปี 2559' , code: 2559 },
           {text: 'ปี 2560' , code: 2560 },
           {text: 'ปี 2561' , code: 2561 },
           {text: 'ปี 2562' , code: 2562 },
         ],
        opt:null,
        chartData:{
        labels: [],
        datasets: [
          {
            backgroundColor: ["#1abc9c", "#f1c40f", "#2ecc71",'#e67e22','#3498db','#e74c3c','#9b59b6','#ecf0f1','#34495e','#95a5a6','#16a085'],
          }
        ]
      },
      datacollection: {
      //Data to be represented on x-axis
      labels: [],
      datasets: [
     
        {
              label: 'ชาย',
              backgroundColor: '#f87976',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
         {
              label: 'หญิง',
              backgroundColor: '#91AAEE',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
        {
              label: 'รวม',
              backgroundColor: '#D3AAE4',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        }
      ],
      
      },
      datacollectionCC: {
      //Data to be represented on x-axis
      labels: [],
      datasets: [
      
        {
              label: 'ชาย',
              backgroundColor: '#f49c29',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
         {
              label: 'หญิง',
              backgroundColor: '#e74848',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
        {
              label: 'รวม',
              backgroundColor: '#8f65b2',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        }
      ],
      
      }
    }
    },
   async created(){
       var d = new Date();
        var n = d.getFullYear()+542;
        var sub =  n.toString().substring(2,4)
         this.setyear = n
        // var sub2 = sub.substring(2,4)
        
        console.log(sub)
     this.getListCC = await general.getListsCC()
      await axios.get("../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=33&yymmBegin="+(n-9).toString().substring(2,4)+"00&yymmEnd="+sub+"00")
          .then((response) => {
            let a = []
            let testdata = []
            for(let i=0; i<response.data.length; i++){
              let yearDesc = '25'+response.data[i].yymm.toString().substring(0,2)
              a.push('ปี  '+'25'+response.data[i].yymm.toString().substring(0,2))

            }
            console.log(response)
            //  this.datacollection.datasets[0].data =response.data.map(r=>r.houseNormal)
             this.datacollection.datasets[0].data =response.data.map(r=>r.male)
             this.datacollection.datasets[1].data = response.data.map(r=>r.female)
             this.datacollection.datasets[2].data = response.data.map(r=>r.total)
             this.datacollection['labels'] = a 
             this.$refs.test3.renderChart(this.datacollection,this.setOptions)
            //  this.$refs.test2.renderChart(this.datacollection)
      });
      // this.setyear = n
        // var d = new Date();
        // var n = d.getFullYear();
        
        // console.log('getfullyear' + (n+543))
      //รายปี
      // const response = await axios.get("/api/stat/statcenter/v1/list?action=41&yymm="+(this.yymm.code.toString().substring(2,4)+'00'))
      // this.chartData['labels'] = response.data.map(r=>r.ccDesc)
      // this.chartData.datasets[0].data =response.data.map(r=>r.total)
      // this.$refs.test.renderChart(this.chartData)
     let responseCC = await axios.get("../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=53&yymmBegin="+(n-19).toString().substring(2,4)+"00&yymmEnd="+sub+"00&cc=10")
          let aCC = []
            for(let i=0; i<responseCC.data.length; i++){
              aCC.push('ปี  '+'25'+responseCC.data[i].yymm.toString().substring(0,2))

            }
            //  this.datacollectionCC.datasets[0].data =responseCC.data.map(r=>r.houseNormal)
             this.datacollectionCC.datasets[0].data =responseCC.data.map(r=>r.male)
             this.datacollectionCC.datasets[1].data = responseCC.data.map(r=>r.female)
             this.datacollectionCC.datasets[2].data = responseCC.data.map(r=>r.total)
             this.datacollectionCC['labels'] = aCC
             this.$refs.test2.renderChart(this.datacollectionCC,this.setOptions)
     
    },
   async mounted(){
    
    },
  methods : {
   async checkdata(){
           const response = await axios.get("../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=43&yymm="+(this.yymm.code.toString().substring(2,4)+'00'))
           this.chartData['labels'] = response.data.map(r=>r.ccDesc)
           this.chartData.datasets[0].data =response.data.map(r=>r.total)
           this.$refs.test.renderChart(this.chartData,this.setOptions)
     },
   async checkCC(){ 
          this.datacollectionCC =  {
      //Data to be represented on x-axis
      labels: [],
      datasets: [
        //  {
        //       label: 'บ้านรวม',
        //       backgroundColor: '#52cb9f',
        //       pointBackgroundColor: 'white',
        //       borderWidth: 1,
        //       pointBorderColor: '#249EBF',
        //       data: []
        // },
        {
              label: 'ชาย',
              backgroundColor: '#f49c29',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
         {
              label: 'หญิง',
              backgroundColor: '#e74848',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
        {
              label: 'รวม',
              backgroundColor: '#8f65b2',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        }
      ],
      }
          const responseCC = await axios.get("../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=53&yymmBegin="+(this.setyear-20).toString().substring(2,4)+"00&yymmEnd="+ this.setyear.toString().substring(2,4)+"00&cc="+this.province.code)
          console.log('responsecc')
         
          let aCC = []
            for(let i=0; i<responseCC.data.length; i++){
              aCC.push('ปี  '+'25'+responseCC.data[i].yymm.toString().substring(0,2))

            }
            //  this.datacollectionCC.datasets[0].data =responseCCdata.map(r=>r.houseNormal)
             this.datacollectionCC.datasets[0].data =responseCC.data.map(r=>r.male)
             this.datacollectionCC.datasets[1].data = responseCC.data.map(r=>r.female)
             this.datacollectionCC.datasets[2].data = responseCC.data.map(r=>r.total)
             this.datacollectionCC['labels'] = aCC 
             this.$refs.test2.renderChart(this.datacollectionCC,this.setOptions)
     },
},

  computed:{
  
  },

  }

</script>